import React from "react";
import mainbanner1 from "../../pages/assets/probimainbanner2.jpg";

const Hero1 = () => {
  return (
    <div
      className="h-screen w-full bg-cover bg-center flex items-center justify-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(${mainbanner1})`,
      }}
    >
      {/* Content */}
      <div className="text-white px-4 text-center max-w-3xl font-lato">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          Your <span className=" glass">Gateway</span> to the Future of Crypto
          Investment
        </h1>
        <p className="text-lg md:text-xl mb-6">
          Join our platform to explore innovative tools and grow your wealth in
          the crypto world. Login now to get started!
        </p>
        <button
          className="px-8 py-4 text-lg font-semibold text-white bg-secondary-500 rounded-lg shadow-lg hover:bg-secondary-600 transition"
          onClick={() => (window.location.href = "/login")}
        >
          Login
        </button>
      </div>
    </div>
  );
};

export default Hero1;
